import React from 'react';
/* Cookie */
import CookieConsent from "react-cookie-consent";

import containerLayout from '../assets/js/ContainerLayout.enum';



/** Components */
import Layout from '../components/layout';
import SEO from '../components/seo';
import Banner from '../components/Banner/Banner';
import Wrapper from '../components/Wrapper/Wrapper';
import ContactForm from '../components/ContactForm/ContactForm'

/** Images */
/*** Services */
import imgServiceMassage from '../images/services/1-2.jpg';
import imgServiceTreatmentBody from '../images/services/6-2.jpg';
import imgServiceLaser from '../images/services/9-1.jpg';
import imgServiceNailVarnish from '../images/services/8-1.jpg';
import imgServiceSolarium from '../images/services/12-1.jpg';
import imgServiceMud from '../images/services/15-1.jpg';
import imgServiceSIC3 from '../images/services/15-2.jpg';
import imgServiceFace from '../images/services/14-6.jpg';
import imgServiceMakeUp from '../images/services/7-5.jpg';
import imgServiceManicure from '../images/services/2-6.jpg';

/*** Partner */
import imgPartnerHorizontal from '../images/partner/logosHorizontal.png';
import imgPartnerHorizontal_part1 from '../images/partner/logosHorizontal_Part1.png';
import imgPartnerHorizontal_part2 from '../images/partner/logosHorizontal_Part2.png';

/*** Products */
import imgProductAustralianGold from '../images/products/australian-gold.jpg';
import imgProductEsthederm from '../images/products/esthederm.jpg';
import imgProductGehwol from '../images/products/gehwol.jpg';
import imgProductGiftCard from '../images/products/gift-card.jpg';
import imgProductMariaGallard from '../images/products/maria-gallard.jpg';
import imgProductNails from '../images/products/nails.jpg';
import imgProductPaoloGuatelli from '../images/products/paolo-guatelli.jpg';
import imgProductPhantasya from '../images/products/phantasya.jpg';
import imgProductPhura from '../images/products/phura.jpg';

import imgStaff from '../images/staff/staff.jpg';

/** FA icons */
import { config,library } from '@fortawesome/fontawesome-svg-core';
import {
  faTimes,
  faBars,
  faMapMarked,
  faMapMarker,
  faMapMarkedAlt,
  faMapMarkerAlt,
  faPhone,
  faFax,
} from '@fortawesome/free-solid-svg-icons';

import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';

library.add(faTimes);
library.add(faBars);
library.add(faMapMarked);
library.add(faMapMarkedAlt);
library.add(faMapMarker);
library.add(faMapMarkerAlt);
library.add(faPhone);
library.add(faFax);
library.add(faFacebook);
library.add(faInstagram);

const sections = {
  about: {
    name: 'about',
    text: 'Chi siamo',
  },
  gallery: {
    name: 'gallery',
    text: 'Gallery',
  },
  servizi: {
    name: 'servizi',
    text: 'Servizi',
  },
  contattaci: {
    name: 'contattaci',
    text: 'Contattaci',
  },
  info: {
    name: 'info-contatti',
    text: 'info',
  },
}

const IndexPage = () => {
  const wrapper1 = {
    header: {
      title: '',
      subtitle: '',
      classes: [''],
      image: imgStaff
    },
    items: [
      <div>
        <div className="p">
          <b>Anita Cristoforetti</b>, innamorata della sua professione e con tanta voglia di crescere, apre <b>Estetica Orchidea</b> nel <b>2006</b>.
          Nel corso degli anni hanno iniziato a lavorare con noi <b>Sabrina</b> e successivamente <b>Sara</b>, mentre la nostra collaboratrice <b>Mariella</b> si occupa dell'accoglienza e reception.
          Il nostro team qualificato e costantemente aggiornato provvederà a farvi ottenere i risultati che cercate.
        </div>
        <p>Istituto di Estetica Orchidea nasce con l’intento di offrire servizi
          estetici altamente qualificati. Scoprirete un ambiente distensivo e
          rilassante, adatto per accogliervi con cortesia e professionalità. </p>
      </div>,
    ],
    styles: ['style1'],
    containerLayout: containerLayout.BOOK,
  };

  const brands = {
    header: {
      title: 'Prodotti',
      subtitle: 'Quello che puoi trovare da noi',
      classes: ['major'],
    },
    items: [
      {
        image: imgProductAustralianGold,
        text: 'Australian Gold: Intensificatori, autoabbronzanti, protezioni solari e idratanti.',
      },
      {
        image: imgProductEsthederm,
        text: 'Linea creme esthederm',
      },
      {
        image: imgProductGehwol,
        text: 'linea specifica Gehwol per mani e piedi',
      },
      {
        image: imgProductPhura,
        text: 'Trattamento del viso 100% vegetale dichiarata dall’Istituto di Chimica Organica',
      },
      {
        image: imgProductMariaGallard,
        text: 'Valorizzate la vostra bellezza e godetevi un viaggio lussuoso nel mondo dei prodotti e dei trattamenti di Maria Galland',
      },
      {
        image: imgProductNails,
        text: 'Smalti: tutti i colori +1',
      },
      {
        image: imgProductPaoloGuatelli,
        text: 'Linea prodotti Paolo Guatelli',
      },
      {
        image: imgProductPhantasya,
        text: 'La collezione Phantasya viene creata con cristalli Swarovski e pietre preziose',
      },
      {
        image: imgProductGiftCard,
        text: 'Stupisci chi vuoi bene con un regalo originale⭐️',
      }
    ],
    styles: ['style1'],
    containerLayout: containerLayout.POLAROID,
  }

  const services = {
    header: {
      title: 'Servizi',
      subtitle: 'Ecco cosa offriamo',
      classes: ['major'],
    },
    items: [
      {
        image: imgServiceMassage,
        title: 'Massaggi',
        subtitle: "Cabina relax Orchidea con vasca emozionale Oceano",
        text: `Per i tuoi momenti di relax e sollievo auto-equilibrante del corpo, eseguiamo massaggi di tipo:
        rilassante olistico connettivale, sportivo defaticante, linfo drenante, distensivo e pre-natale per la dolce attesa`,
      },
      {
        image: imgServiceTreatmentBody,
        title: 'Trattamenti specifici corpo',
        subtitle: '',
        text: `Nati dall’universo dell’estetica professionale, i trattamenti corpo
        institut esthederm agiscono efficacemente sull’armonia della silhouette e sulla bellezza della pelle.
        Formule che coniugano piacere e alta tecnologia per una pelle bella, soda e tonica, senza compromessi`,
      },
      {
        image: imgServiceLaser,
        title: 'Epilazione Classica e con Laser',
        subtitle: 'Affida la tua pelle a mani esperte',
        text:
          `Con il nostro Laser Be-Diode 808 nM puoi dire addio ai peli superflui!
          Risultati sorprendenti e duraturi con sedute più brevi e piacevoli.
          Per garantire il massimo della professionalità e dell'igiene 
          utilizziamo guanti e spatole sterilizzate e monouso.
          `
      },
      {
        image: imgServiceNailVarnish,
        title: 'Smalto semipermanente',
        subtitle: '',
        text:
          'Applicazione di Smalto semipermanente con colori sofisticati e brillanti dalla durata di circa tre settimane per una manicure e pedicure sempre perfette.',
      },
      {
        image: imgServiceSolarium,
        title: 'Solarium Anti-age',
        subtitle: 'In questo Istituto il primo programma Solarium Anti-age',
        text:
          `UV-A per un'abbronzatura intensa, dorata ed invidiabile.
          UV-B la stimolazione della melanina e della vitamine. 
          LUCE BLUE per una pelle senza imperfezioni.
          LUCE ROSSA Collagene per una pelle sempre giovane`,
      },
      {
        image: imgServiceMud,
        title: 'Fangoterapia',
        subtitle: 'Mud system',
        text:
          `Una Linea di fanghi peloidi attivi ideali sia per trattamenti di “Aromaterapia”,
          che per svolgere applicazioni cabina efficaci ed accattivanti sugli inestetismi del corpo quali: 
          Cellulite Edematosa, Cellulite Fibrosa, Adiposità Corpo e Accumulo di Liquidi Interstiziali`,
      },
      {
        image: imgServiceSIC3,
        title: 'Sic 3',
        subtitle: 'Impacco e Assorbimento alla Fosfatidilcolina',
        text:
          `Il trattamento cabina SIC3 è suddiviso per affrontare in modo completo ed efficace gli inestetismi della: Cellulite Edematosa, Cellulite Fibrosa e Adiposità Corpo`,
      },
      {
        image: imgServiceFace,
        title: 'Trattamenti specifici viso',
        subtitle: 'Metodo olistico di Maria Galland',
        text:
          `Basato sull’energia, sulla precisione e sull’armonia, altamente personalizzato, professionale e perfezionato grazie a una ricerca e a uno sviluppo all’avanguardia. 
          Maria Galland Paris è sinonimo di trattamenti per il viso esclusivi che forniscono risultati eccezionali, immediati e visibili.`,
      },
      {
        image: imgServiceMakeUp,
        title: 'Make Up',
        subtitle: 'Con la linea Paolo Guatelli',
        text: `Applichiamo uno stile personale fatto di sensibilità verso l’estetica. Un'interpretazione il concetto di Bellezza, sempre più aperta all’ascolto dell’Io profondo e incentrata su una filosofia di autenticità, rispetto e integrità della persona.`,
      },
      {
        image: imgServiceManicure,
        title: 'Manicure e pedicure',
        subtitle: `L'igiene è il principio fondamentale per la professionalità e la sicurezza di uno studio`,
        text: `
          Nel nostro istituto trattiamo gli strumenti di lavoro con procedure scrupolose
          utilizzando l'<b>autoclave</b> per garantire l'eliminazione delle spore batteriche cancellando ogni segno di vita.
          Utilizziamo asciugamani in panno monouso e inoltre riserviamo un set di lime e raspa personali ad ogni cliente
          per evitare qualsiasi pericolo d'infezione`,
      }
    ],
    styles: ['style2'],
    containerLayout: containerLayout.ROUNDED_PHOTO,
  };

  const partner = {
    header: {
      title: '',
      subtitle: '',
      classes: [''],
    },
    items: [
      <div className="partner">
        <div className="partner_logo">
          <img id="complete" alt="complete-partner" src={imgPartnerHorizontal}></img>
          <img id="logoPart1" alt="partner-part-1" src={imgPartnerHorizontal_part1}></img>
          <img id="logoPart2" alt="partner-part-2" src={imgPartnerHorizontal_part2}></img>
        </div>
      </div>,
    ],
    styles: ['style2'],
    containerLayout: "default",
  }

  const creditErboristeria = {
    header: {
      title: 'In collaborazione con Erboristeria Erba del Vicino',
      subtitle: 'Programma dimagra + trattamento',
      classes: [''],
    },
    items: [
      <div>
        <div className="p">
          Metodo sicuro, semplice ed efficace per dimagrire e rimodellare il tuo corpo.
          Utile per tutti come depurativo e disintossicante, molto efficace per coloro che hanno il metabolismo bloccato per varie motivazioni (ipotiroidismo).
          Adatto nella prevenzione per le donne in fase di pre-menopausa.
          Nel trattamento completo verrà dato in omaggio un controllo Dimagra ed un trattamento linfodrenaggio.
        </div>
        <a href="https://www.lerbadelvicinodal1993.it/441543602" target="_blank" rel="noopener noreferrer">VAI AL SITO</a>
      </div>
    ],
    styles: ['style1'],
    containerLayout: containerLayout.BOOK,
  };

  return (
    <Layout
      sections={sections}
      caller='index'
    >
      <CookieConsent
        location="bottom"
        buttonText="CHIUDI IL BANNER"
        cookieName="myAwesomeCookieName2"
        style={{ background: "#2B373B" }}
        buttonStyle={{ background: "#f32853", color: "white", fontSize: "15px" }}
        expires={150}
        enableDeclineButton
        onDecline={() => window.location.href = "/privacy"}
        declineButtonText="Privacy Policy"
      >
        Informativa:
        <span style={{ fontSize: "11px" }}> Questo sito o gli strumenti terzi da questo utilizzati si avvalgono di cookie necessari al funzionamento ed utili alle finalità illustrate nella privacy policy.
        Se vuoi saperne di più, consulta la Privacy Policy.
Chiudendo questo banner, scorrendo questa pagina, cliccando su un link o proseguendo la navigazione in altra maniera, acconsenti all’ uso dei cookie.</span>
      </CookieConsent>
      <Banner title="Estetica Orchidea" />
      <a id="about" href="#" />
      <Wrapper
        styles={wrapper1.styles}
        header={wrapper1.header}
        items={wrapper1.items}
        containerLayout={wrapper1.containerLayout}
      />

      <a id="servizi" href="#" />
      <Wrapper
        styles={services.styles}
        header={services.header}
        items={services.items}
        containerLayout={services.containerLayout}
      />{' '}
      <a id="prodotti" href="#" />
      <Wrapper
        styles={brands.styles}
        header={brands.header}
        items={brands.items}
        containerLayout={brands.containerLayout}
      />{' '}
      <Wrapper
        styles={partner.styles}
        header={partner.header}
        items={partner.items}
        containerLayout={partner.containerLayout}
      />{' '}
      <Wrapper
        styles={creditErboristeria.styles}
        header={creditErboristeria.header}
        items={creditErboristeria.items}
        containerLayout={creditErboristeria.containerLayout}
      />{' '}

      <a id="contattaci" href="#" />
      <ContactForm />
      <SEO title="Home" keywords={[`gatsby`, `application`, `react`]} />{' '}
      <a id="info-contatti" href="#" />

    </Layout>
  );
}

export default IndexPage